import React, { FC } from "react";
import { Autocomplete, TextField, Box } from "@mui/material";

// You can reuse your existing types or define a simple one here
interface AutocompleteProps {
  id?: string;
  label?: string;
  placeholder?: string;
  dropArr: { label: string; value: string | number }[];
value?: string | number | null; // Allow null/undefined here
  onChange: (val: string | number) => void;
  required?: boolean;
  error?: boolean;
  errorText?: string;
  readOnly?: boolean;
}

const SingleAutocomplete: FC<AutocompleteProps> = (props) => {
  const { id, label, placeholder, dropArr, value, onChange, required, error, errorText, readOnly } = props;

  // 1. Find the matching object if it exists in the dropdown list
  const selectedOption = dropArr.find((opt) => opt.value === value) || null;

  // 2. If no object matches, use the raw value. 
  // IMPORTANT: Autocomplete freeSolo expects numbers to be strings for the input display.
  const displayValue = selectedOption || (value !== null && value !== undefined ? String(value) : null);

  return (
    <Box>
      <Autocomplete
        freeSolo
        id={id}
        options={dropArr}
        disabled={readOnly}
        // Use our computed displayValue
        value={displayValue} 
        
        onChange={(event, newValue: any) => {
          // If newValue is an object (from list), take .value (the ID)
          // If newValue is a string (manual type), take the string
          const finalVal = newValue && typeof newValue === 'object' ? newValue.value : newValue;
          onChange(finalVal ?? "");
        }}

        onInputChange={(event, newInputValue) => {
          // Only trigger onChange here if the user is typing (not just selecting)
          // To avoid double-calls, some people prefer handling this via onChange only,
          // but for freeSolo "type-to-create", this ensures the state is always fresh.
          if (newInputValue !== String(selectedOption?.label)) {
             onChange(newInputValue);
          }
        }}

        renderInput={(params) => (
          <TextField
            {...params}
            margin="normal"
            label={label}
            placeholder={placeholder}
            required={required}
            error={error}
            helperText={errorText}
          />
        )}
      />
    </Box>
  );
};

export default SingleAutocomplete;